/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import $ from 'jquery';
import {
  Popup, Icon,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import api from '../../api';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import WithRouter from '../Extensions/WithRouter';
import HeaderError from '../SubHeader/HeaderError';
import HeaderLinkDetail from '../SubHeader/HeaderLinkDetail';

class PolicyRevisionPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      overviewSummary: {},
      isLoadError: false,
      errorHeader: null,
      errorBody: null,
    };
  }

  componentDidMount() {
    $(document).on(
      'mouseover',
      '.result_header_inner .result_header_box .name .file_name span',
      this.handleMouseOver
    );
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isLoading } = this.state;
    const { params, state } = this.props;

    if (prevState.isLoading !== isLoading && isLoading) {
      const navState = state.user.transientNavigationState;
      const detailType = navState ? state.user.currentPrecisionLevel : undefined;

      this.getPolicyRevisionSummary(params.idReport, detailType);

      if (navState) {
        state.user.clearTransientNavigationState();
      }
    }
  }

  componentWillUnmount() {
    $(document).off(
      'mouseover',
      '.result_header_inner .result_header_box .name .file_name span',
      this.handleMouseOver
    );
  }

  handleMouseOver = (event) => {
    const $this = $(event.currentTarget);
    if (event.currentTarget.offsetWidth < event.currentTarget.scrollWidth && !$this.attr('title')) {
      $this.attr('title', $this.text());
    }
  };

  onUpdateLoading = () => {
    this.setState({
      isLoading: true,
    });
  };

  getPolicyRevisionSummary = async (value, type) => {
    const { state } = this.props;

    try {
      const response = await api.getPolicyRevisionSummary(value, type);
      const data = convertPropertiesToCamelCase(response.response);

      this.setState({
        overviewSummary: data,
      });
      state.company.setPolicyRevisionSummary(data);
    } catch (err) {
      console.log(err);
      const o = err.data.response;
      if (!o) {
        this.setState({
          isLoadError: true,
          errorHeader: 'Access Denied',
          errorBody: 'Unknown error. Please contact Insignary.',
        });
      } else if (o.error === '422-401') {
        this.setState({
          isLoadError: true,
          errorHeader: 'Access Denied',
          errorBody: 'You do not have permission to access this file.',
        });
      }
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  goBack = () => {
    console.log('aa');
    history.back();
  };

  abbreviateNumber = (value) => {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4;
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        );
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  };

  render() {
    const { t } = this.props;
    const {
      overviewSummary, isLoadError, errorHeader, errorBody
    } = this.state;
    const {
      mostFound,
      policyCount,
      revisionFileName,
      currentPrecisionLevel
    } = overviewSummary;
    const tooltipStyle = {
      fontSize: '11px',
      fontWeight: '500',
    };

    return (
      <div>
        <div className="result_header has_expand">
          <div className="result_header_inner">
            <div className="result_header_box">
              {
                !isLoadError ? (
                  <div className="name">
                    <div className="prev_button">
                      <a onClick={this.goBack} />
                    </div>
                    <div className="file_name">
                      <span>
                        {revisionFileName}
                      </span>
                      {currentPrecisionLevel === 'narrow' ? (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="arrow alternate circle up"
                              />
                            </a>
                          )}
                          content={t('modal.content.precision_level_narrow')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      ) : null}
                      {currentPrecisionLevel === 'medium' ? (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="exchange"
                              />
                            </a>
                          )}
                          content={t('modal.content.precision_level_medium')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      ) : null}
                      {currentPrecisionLevel === 'broad' ? (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="arrow alternate circle down"
                              />
                            </a>
                          )}
                          content={t('modal.content.precision_level_broad')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      ) : null}
                    </div>
                  </div>
                )
                  : (
                    <HeaderError
                      errorHeader={errorHeader}
                      errorBody={errorBody}
                      goBack={this.goBack}
                    />
                  )
              }
              <HeaderLinkDetail overviewSummary={overviewSummary} props={this.props} />
            </div>
          </div>
        </div>
        <div className="contents_summary">
          <div className="contents_summary_inner">
            <div className="contents_summary_box">
              <div className="overview">
                <table className="summary_item_table">
                  <colgroup>
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '1px' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '' }} />
                  </colgroup>
                  <tbody>
                    {
                      policyCount && policyCount.total ? (
                        <tr>
                          <td>
                            <div className="summary_item">
                              <p className="label">{t('panel.menu.violated_policy')}</p>
                              {
                                policyCount.total !== 0 ? (
                                  <p className="value orange">{this.abbreviateNumber(policyCount.total)}</p>
                                ) : (
                                  <p className="value">{this.abbreviateNumber(policyCount.total)}</p>
                                )
                              }
                            </div>
                          </td>
                          <td>
                            <div className="bg_stick" />
                          </td>
                          <td>
                            <div className="summary_item">
                              <p className="label">{t('panel.menu.component')}</p>
                              {
                                policyCount && policyCount.component !== 0 ? (
                                  <p className="value orange small">{this.abbreviateNumber(policyCount.component)}</p>
                                ) : (
                                  <p className="value small">{this.abbreviateNumber(policyCount.component)}</p>
                                )
                              }
                            </div>
                          </td>
                          <td>
                            <div className="summary_item">
                              <p className="label">{t('panel.menu.security')}</p>
                              {
                                policyCount && policyCount.security !== 0 ? (
                                  <p className="value orange small">{this.abbreviateNumber(policyCount.security)}</p>
                                ) : (
                                  <p className="value small">{this.abbreviateNumber(policyCount.security)}</p>
                                )
                              }
                            </div>
                          </td>
                          <td>
                            <div className="summary_item">
                              <p className="label">{t('panel.menu.license')}</p>
                              {
                                policyCount && policyCount.license !== 0 ? (
                                  <p className="value orange small">{this.abbreviateNumber(policyCount.license)}</p>
                                ) : (
                                  <p className="value small">{this.abbreviateNumber(policyCount.license)}</p>
                                )
                              }
                            </div>
                          </td>
                          <td>
                            <div className="summary_item">
                              <p className="label">{t('panel.menu.litigator')}</p>
                              {
                                policyCount && policyCount.litigator !== 0 ? (
                                  <p className="value orange small">{this.abbreviateNumber(policyCount.litigator)}</p>
                                ) : (
                                  <p className="value small">{this.abbreviateNumber(policyCount.litigator)}</p>
                                )
                              }
                            </div>
                          </td>
                          <td>
                            <div className="list_wrap">
                              <p className="list_title">{t('panel.menu.most_violated')}</p>
                              <ul>
                                {mostFound && mostFound.length !== 0 ? (
                                  <li className="normal">
                                    <table>
                                      <colgroup>
                                        <col style={{ width: '65%' }} />
                                        <col style={{ width: '35%' }} />
                                      </colgroup>
                                      <tbody>
                                        {mostFound.map((item) => {
                                          return (
                                            <tr key={item.rank}>
                                              <td>
                                                <span className="name">
                                                  {item.name}
                                                </span>
                                              </td>
                                              <td>
                                                <span className="val">{item.category}</span>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </li>
                                ) : null}
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ) : null
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(PolicyRevisionPanel))));
